import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/services/core/base/base.service';
import { Observable } from 'rxjs';

const routes = {
  placeOrder: 'order/place-order',
  allOrders: 'order/all-open-orders-by-table',
  singleOrder: 'order',
  makePayment: 'order/make-payment-dine-in',
  cancelOrder: 'order/cancel-orders',
  cancelSingleOrder: 'order/cancel-order',
  confirmPayment: 'order/close-order',
  verifyPayment: 'payments/verify',
};

@Injectable({
  providedIn: 'root',
})
export class OrdersService extends BaseService<any> {
  constructor(public http: HttpClient) {
    super(http);
  }

  createOrder(payload: any): Observable<any> {
    return this.sendPost(this.baseUrl(routes.placeOrder), payload);
  }

  makePayment(payload: any): Observable<any> {
    return this.sendPost(this.baseUrl(routes.makePayment), payload);
  }

  getDishesForSelectedTable(payload: any): Observable<any> {
    return this.sendPost(this.baseUrl(routes.allOrders), payload);
  }

  // api/v1/order/cancel-orders/41
  cancelOrder(tableId: number): Observable<any> {
    return this.sendPut(this.baseUrl(`${routes.cancelOrder}/${tableId}`), {});
  }

  cancelSingleOrder(orderId: number): Observable<any> {
    return this.sendPut(
      this.baseUrl(`${routes.cancelSingleOrder}/${orderId}`),
      {}
    );
  }

  confirmPayment(recentOrderId: number): Observable<any> {
    return this.sendPut(
      this.baseUrl(`${routes.confirmPayment}/${recentOrderId}`),
      {}
    );
  }

  verifyPayment(reference: string): Observable<any> {
    return this.sendPost(this.baseUrl(`${routes.verifyPayment}/${reference}`), {});
  }
}
